import { createAction, props } from '@ngrx/store';

/**
 * NavBar Action Types
 */
export const APP_NAVBAR_ACTION = {
  OPEN_DIALOG: '[App] APP_NAVBAR_DIALOG',
};

export const AppNavBarSetNavigation = createAction('[App] APP_NAVBAR_NAVIGATION', props<{payload?: object}>());
export const AppNavBarOpenDialog = createAction('[App] APP_NAVBAR_DIALOG', props<{payload: any}>());
export const AppNavBarOpenPopup = createAction('[App] APP_NAVBAR_OPEN_POPUP', props<{payload: any}>());
